<template>
  <div v-if="visible" class="splash" aria-hidden="true">
    <div class="splash__logo-wrap">
      <div class="splash__logo" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'

export default {
  name: 'SplashScreen',
  emits: ['done'],
  setup(_, { emit }) {
    const visible = ref(true)
    const isMobile = ref(false)

    onMounted(() => {
      // Проверяем, мобильное устройство или планшет
      isMobile.value = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || 
                       (window.matchMedia && window.matchMedia('(max-width: 1024px)').matches)
      
      // На мобильных/планшетах - 4 секунды, на вебе - 3 секунды
      const duration = isMobile.value ? 4000 : 3000
      const timer = setTimeout(() => {
        visible.value = false
        emit('done')
      }, duration)
      return () => clearTimeout(timer)
    })

    return { visible, isMobile }
  }
}
</script>

<style lang="scss" scoped>
.splash {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;

  &__logo-wrap {
    // Без анимации
  }

  &__logo {
    width: 500px;
    height: 160px;
    background: url(~@/assets/logo.png) center / contain no-repeat;
    
    @media (max-width: 768px) {
      width: 400px;
      height: 128px;
    }
  }
}
</style>
